import React from 'react';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  // Calculate percentage, ensuring it doesn't exceed 100%
  const percentage = Math.min(100, Math.max(0, currentStep / totalSteps * 100));
  return <div className="w-full bg-gray-200 h-1 fixed top-[27px] sm:top-[30px] left-0 z-40" data-id="element-121">
      <div className="bg-progress h-full transition-all duration-500 ease-out" style={{
      width: `${percentage}%`
    }} data-id="element-122" />
    </div>;
}